import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SystemsService } from '../services/systems.service';
import { inject } from '@angular/core';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const moduleAccessGuard = (requiredModuleCode: string): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const systemsService = inject(SystemsService);
    const router = inject(Router);

    const userId = authService.getUserId();
    if (!userId) {
      router.navigate(['/login']);
      return false;
    }

    return systemsService.getModulesByUser(userId).pipe(
      map(modules => {
        const hasAccess = modules.some(m => m.code === requiredModuleCode);
        if (!hasAccess) {
          router.navigate(['/dashboard'], {
            queryParams: { accessDenied: 'true', module: requiredModuleCode }
          });
          return false;
        }
        return true;
      }),
      catchError(() => {
        router.navigate(['/dashboard'], {
          queryParams: { accessDenied: 'true', module: requiredModuleCode }
        });
        return of(false);
      })
    );
  };
};